module.exports = __webpack_public_path__ + "img/pro7.3bffea04.png";